import { secureRequest } from 'utils/request';

export const getRoutesRequest = (routes: number[] | string | null) =>
  secureRequest(
    `/api/v1/map/routes?q=${Array.isArray(routes) ? routes.join(',') : routes}`
  );

export const getRouteTrajectory = (route: any) => {
  return secureRequest(`api/v1/map/route/trajectory/${route}`);
};
export const getRoute = (id: number, path: string) =>
  secureRequest(`/api/v1/map/route/${id}`, [path]);

export const getStop = (id: number, path: string) =>
  secureRequest(`/api/v1/map/stop/${id}`, [path]);
